import MultiMultipleChoicePure from './MultiMultipleChoicePure';

export default {
    data() {
        return {
            state: this.controller.state
        };
    },
    render: function (h) {
        return h(MultiMultipleChoicePure, {
            props: {
                question: this.controller.getQuestion(),
                choices: this.controller.getChoices(),
                select: this.controller.select.bind(this.controller),
                state: this.state
            },
            on: {
                // done: () => this.controller.done()
                done: () => {
                    this.$emit('done');
                }
            }
        });
    },
    props: {
        controller: {
            type: Object,
            required: true
        }
    }
};
